const DELTA = 100
export const translate = (currentIndex: number, nextIndex: number) => {
  if (nextIndex > currentIndex) {
    return {
      from: `translate3d(0,${DELTA}%,0)`,
      leave: `translate3d(0,-${DELTA}%,0)`
    }
  }
  if (nextIndex < currentIndex) {
    return {
      from: `translate3d(0,-${DELTA}%,0)`,
      leave: `translate3d(0,${DELTA}%,0)`
    }
  }

  return {
    from: `translate3d(0,0%,0)`,
    leave: `translate3d(0,0%,0)`
  }
}
